import { useEffect } from 'react'
import { View } from 'react-native'
import Animated, { Easing, useAnimatedStyle, useSharedValue, withRepeat, withTiming } from 'react-native-reanimated'
import Svg, { Circle, Defs, G, Path, RadialGradient, Stop } from 'react-native-svg'

export const HozanimatedLoader = () => {
  const rotate = useSharedValue(0)

  useEffect(() => {
    rotate.value = withRepeat(withTiming(360, { duration: 2000, easing: Easing.linear }), -1, false)
  }, [rotate])

  const animatedStyle = useAnimatedStyle(() => ({
    transform: [{ rotate: `${rotate.value}deg` }],
  }))

  return (
    <View className="flex items-center justify-center">
      <View style={{ width: 80, height: 80 }}>
        <Animated.View
          style={[
            animatedStyle,
            {
              position: 'absolute',
              width: 80,
              height: 80,
            },
          ]}
        >
          <Svg viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" width="80" height="80">
            <G>
              <Circle
                strokeLinecap="round"
                fill="none"
                strokeDasharray="64 64"
                stroke="#febd17"
                strokeWidth="4"
                r="40"
                cy="50"
                cx="50"
              />
            </G>
          </Svg>
        </Animated.View>
        <Svg width={80} height={80} viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
          <G>
            <Defs>
              <RadialGradient
                id="flameGradient"
                cx="53.53"
                cy="-3.56"
                fx="53.53"
                fy="-3.56"
                r="38.64"
                gradientTransform="translate(-4.06 62.57) scale(1.01 -1)"
                gradientUnits="userSpaceOnUse"
              >
                <Stop offset="0.03" stopColor="#f9d626" />
                <Stop offset="0.13" stopColor="#f9cd2e" />
                <Stop offset="0.38" stopColor="#f9b940" />
                <Stop offset="0.56" stopColor="#f8af3c" />
                <Stop offset="0.87" stopColor="#f59630" />
                <Stop offset="0.96" stopColor="#f48d2c" />
              </RadialGradient>
              <RadialGradient
                id="flameGlowGradient"
                cx="50.53"
                cy="8.71"
                fx="50.53"
                fy="8.71"
                r="12.19"
                gradientTransform="translate(0 62.57) scale(1 -1)"
                gradientUnits="userSpaceOnUse"
              >
                <Stop offset="0.03" stopColor="#f9ed26" />
                <Stop offset="0.09" stopColor="#f9e928" stopOpacity="0.91" />
                <Stop offset="0.35" stopColor="#f9d831" stopOpacity="0.59" />
                <Stop offset="0.58" stopColor="#f9cb37" stopOpacity="0.34" />
                <Stop offset="0.77" stopColor="#f9c13c" stopOpacity="0.16" />
                <Stop offset="0.92" stopColor="#f9bb3f" stopOpacity="0.04" />
                <Stop offset="1" stopColor="#f9b940" stopOpacity="0" />
              </RadialGradient>
            </Defs>
            <Path
              fill="url(#flameGradient)"
              d="M67.47,59.07c2.75-10.65-3.66-24.04-11.31-31.17-.41-.38-1-.49-1.52-.27-11.81,5.13-20.15,14.24-22.37,23.66-.27,1.25-.4,2.52-.39,3.79.11,7.82,4.98,14.48,11.95,16.96v.02c-4.58-7.3,2.07-12.02,5.05-19.37.2-.46.73-.68,1.19-.49.08.03.16.08.22.13,7.04,5.93,8.6,14.15,4.38,20.13,6.41-1.77,11.32-6.92,12.79-13.4Z"
            />
            <Path
              fill="url(#flameGlowGradient)"
              d="M49.55,35.56c-8.7,0-15.76,7.01-15.76,15.63,0,5.93,3.84,11.08,8.76,13.72,1.02-3.9,4.41-7.51,6.31-12.21.19-.47.72-.69,1.19-.51.09.04.17.09.25.15,4.37,3.68,6.63,8.24,6.7,12.6,5.1-2.7,8.29-7.99,8.3-13.75,0-8.62-7.05-15.63-15.75-15.63Z"
            />
          </G>
        </Svg>
      </View>
    </View>
  )
}
